import { DateTime, Duration } from 'luxon'
import DateFormat from '../../shared/helpers/date-format'
import { safeApiCall } from '../../services/api'

const { dashed } = DateFormat

const MAXMONTHS = 12

// SHEDDWEB-1112 we want to start with 3 months and if it doesn't return call with the next 3 months, at most 4 times (12 months)
// these two constants multiplied together = 12 (one year)
export const MAX_CALLS = 4
export const MONTHS_PER_CALL = 3

export const attendanceInfo = attendance => {
  let capacityForecast
  if (attendance >= 7000) {
    capacityForecast = 'high'
  } else if (attendance >= 4000 && attendance <= 6999) {
    capacityForecast = 'medium'
  } else if (attendance < 4000) {
    capacityForecast = 'low'
  }
  return capacityForecast
}

const nextMonth = currentDate => {
  if (!currentDate.isLuxonDateTime) {
    currentDate = new DateTime(currentDate)
  }
  return currentDate.startOf('month').plus(Duration.fromISO('P1M'))
}

export const startOrEndDateForEvent = (currentDate, isStartOf) => {
  if (!currentDate.isLuxonDateTime) {
    currentDate = new DateTime(currentDate)
  }

  if (isStartOf) return currentDate.plus(Duration.fromObject({ days: 1 }))

  return currentDate
    .startOf('month')
    .plus(Duration.fromObject({ months: MONTHS_PER_CALL }))
    .minus(Duration.fromObject({ days: 1 }))
}

export const getPlanAheadFromEvent = async (
  startDate,
  fromEvent,
  minimumAvailability,
  endDate
) => {
  if (endDate) {
    // used by mobile list view fromEvent
    return safeApiCall(
      'get',
      `/api/plan_ahead_pricing/${fromEvent}?start_date=${dashed(
        startDate
      )}&end_date=${dashed(endDate)}&min_tix=${minimumAvailability}`,
      'Sorry, there was an error.'
    )
  }
  // used by calendar.js monthly and weekly views
  return safeApiCall(
    'get',
    `/api/plan_ahead_pricing/${fromEvent}?start_date=${startDate}&min_tix=${minimumAvailability}`,
    'Sorry, there was an error.'
  )
}

export const getPlanAheadPricing = async (
  startDate,
  fromEvent,
  minimumAvailability,
  endDate,
  skippedMonths = 0
) => {
  if (!startDate) return {}
  if (fromEvent) {
    let { disabledDates, noDatesAvailable, firstAvailableDate, planningInfo } =
      await getPlanAheadFromEvent(
        dashed(startDate),
        fromEvent,
        minimumAvailability,
        null
      )
    // if we have not skipped the maximum months, we move forward a month and make recursive call
    if (noDatesAvailable && skippedMonths <= MAXMONTHS) {
      return getPlanAheadPricing(
        nextMonth(startDate),
        fromEvent,
        minimumAvailability,
        endDate,
        (skippedMonths += 1)
      )
    } else {
      return {
        disabledDates,
        noDatesAvailable,
        firstAvailableDate,
        planningInfo
      }
    }
  }

  // used in !fromEvent /tickets mobile view
  if (endDate) {
    return safeApiCall(
      'get',
      `/api/plan_ahead_pricing/?start_date=${dashed(
        startDate
      )}&end_date=${dashed(endDate)}`,
      'Sorry, there was an error.'
    )
  }

  // index call used in !fromEvent /tickets desktop view
  return safeApiCall(
    'get',
    `/api/plan_ahead_pricing?start_date=${dashed(startDate)}`,
    'Sorry, there was an error.'
  )
}
